import React from "react";
import { Results } from "@elastic/react-search-ui";
import useDraggableScroll from "use-draggable-scroll";
import { getConfig } from "../../../config/faq-config-helper";
import TableHeader from "./TableHeader";
import ListItem from "./ListItem";

const OmronResults = () => {
  const ref = React.useRef(null);
  const { onMouseDown } = useDraggableScroll(ref);

  return (
    <div
      ref={ref}
      onMouseDown={onMouseDown}
      className="u-table u-table--responsive"
    >
      <table className="u-font--s">
        <TableHeader />
        <Results
          view={({ children }) => <tbody>{children}</tbody>}
          resultView={(props) => (
            <ListItem {...props} key={props.result.id.raw} />
          )}
          titleField={getConfig().faqTitleField}
          urlField={getConfig().urlField}
        />
      </table>
    </div>
  );
};

export default OmronResults;
